module.exports = __webpack_public_path__ + "img/Telegram.709e2ea8.png";